import { render, staticRenderFns } from "./EditarAlarma.vue?vue&type=template&id=02bf931d&"
import script from "./EditarAlarma.vue?vue&type=script&lang=ts&"
export * from "./EditarAlarma.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports